import TrendingNavItems  from "./TrendingNavItems";

export default TrendingNavItems;